import { sha256 } from 'ohash'

const emailHashCache = new Map<string, string>()

export const hashEmail = (email: string | null | undefined): string | null => {
	if (!email) return null
	const normalized = email.trim().toLowerCase()
	if (!normalized) return null

	const cached = emailHashCache.get(normalized)
	if (cached) return cached

	const hash = sha256(normalized)
	emailHashCache.set(normalized, hash)
	return hash
}
